module.exports = __webpack_public_path__ + "img/复制2.82f0baf0.svg";